/*
 This is Code Level FFs for UI related features done exclusively to deploy changes till INT env, not to Prod.
 We will have to clean this up after Product validates feature in INT.
 This file should only contain featureFlags which are in active development/testing.
 Any epics/features already released to Prod should not be listed here.
Keep to name of the Function like is<EpicNumber>Enabled for easier tracking of the FFs
*/
const isNotProduction = () => {
    const prodHostNames = ['identityservice.onsolve.net', 'identityservice-euprodstack01.cem.onsolve.eu'];

    return !prodHostNames.includes(window.location.hostname);
};

export const isCRC168Enabled = isNotProduction;
export const isHZMN446Enabled = isNotProduction;
